/******/ (() => { // webpackBootstrap
/*!*******************************!*\
  !*** ./src/js/header-main.js ***!
  \*******************************/
document.addEventListener('DOMContentLoaded', function () {
  var headerBar = document.querySelector('header-component');
  if (!headerBar) return;
  var lastScrollY = window.scrollY;
  var ticking = false;
  function updateHeader() {
    var currentScrollY = window.scrollY;
    var isScrollingDown = currentScrollY > lastScrollY;
    if (isScrollingDown && currentScrollY >= 150) {
      headerBar.classList.add('active');
      headerBar.classList.remove('scrolled-down');
    } else if (currentScrollY < 250) {
      headerBar.classList.remove('active');
    } else if (!isScrollingDown) {
      headerBar.classList.add('scrolled-down');
    }
    lastScrollY = currentScrollY;
    ticking = false;
  }
  window.addEventListener('scroll', function () {
    if (!ticking) {
      requestAnimationFrame(updateHeader);
      ticking = true;
    }
  });
});
/******/ })()
;
//# sourceMappingURL=header-main.js.map